import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { missingEnv } from './config';
import { initIdentity } from './identity';
import './styles.css';
import './sales.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root fehlt in index.html');

const missing = missingEnv();
if (missing.length === 0) initIdentity();

createRoot(container).render(
  <StrictMode>
    {missing.length > 0 ? (
      <div className="auth">
        <div className="auth__card">
          <h1>Konfiguration fehlt</h1>
          <p className="card__meta">
            Diese Env-Variablen sind im Build nicht gesetzt: {missing.join(', ')}. In Netlify unter
            Site configuration → Environment variables ergänzen und neu deployen.
          </p>
        </div>
      </div>
    ) : (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )}
  </StrictMode>,
);
